import { render, staticRenderFns } from "./AppUploadDocumenten.vue?vue&type=template&id=3412e36a&scoped=true&"
import script from "./AppUploadDocumenten.ts?vue&type=script&lang=ts&"
export * from "./AppUploadDocumenten.ts?vue&type=script&lang=ts&"
import style0 from "./AppUploadDocumenten.scss?vue&type=style&index=0&id=3412e36a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412e36a",
  null
  
)

export default component.exports